import { queryOptions } from '@tanstack/react-query'
import { getOrganizationCurrencies } from 'src/queries/organizations/currencies/currencies.network'
import { orgQueryKeys } from 'src/queries/queries.constants'

export const orgCurrencyQueryKeys = {
  /**
   * Delegates to the shared constants factory so the key stays
   * ['organizations', orgId, 'currencies'] — byte-identical to the cache
   * entries written by the legacy useQueryOrgCurrencies hook
   * (src/queries/organizations/currencies.queries.tsx) and still covered by
   * the cross-feature prefix invalidation of `orgQueryKeys.all` in
   * src/hooks/useChargebeeCheckout.tsx.
   */
  list: (orgId: string | undefined) => orgQueryKeys.currencies(orgId),
}

export const orgCurrencyQueries = {
  list: (orgId: string | undefined) =>
    queryOptions({
      queryKey: orgCurrencyQueryKeys.list(orgId),
      queryFn: () => getOrganizationCurrencies(orgId!),
      enabled: Boolean(orgId),
      /**
       * staleTime/gcTime Infinity — static reference data. Redux merged
       * currencies into listResponses[orgId] once and never refetched
       * (consumers guarded dispatch on `organization?.currencies ===
       * undefined`), so a mounted consumer never re-requested it. gcTime
       * Infinity keeps the entry resident after consumers unmount so it isn't
       * evicted and refetched mid-session. Explicit invalidation (e.g. the
       * orgQueryKeys.all prefix invalidation after checkout) still refetches.
       */
      staleTime: Infinity,
      gcTime: Infinity,
    }),
}
